import React from 'react';

/**
 * Search dropdown.
 *
 * @param {string} label, label to show.
 * @param children, slot.
 * @return {JSX.Element}
 * @constructor
 */
const SearchDropdown = ( { label, children, maxHeight = 'auto' } ) => {

  if (typeof maxHeight === 'string' && 'auto' !== maxHeight) {
    maxHeight = parseInt(maxHeight)
  }

  return (
    <div className="denhaag-search-results-dropdown" style={{ maxHeight }}>
      {label && (<div className="denhaag-search-results-dropdown__label">{label}</div>)}
      { children }
    </div>
  );
};

export default SearchDropdown;